import React, { useState, useEffect } from 'react';
import { Card, Form } from 'react-bootstrap';
import CurrencyInput from '../common/CurrencyInput';
import { formatCurrency } from '../../utils/formatters';
import { calculateCostPerSqm } from '../../utils/calculations';

const CostPerSqm: React.FC = () => {
  const [sellingPrice, setSellingPrice] = useState<number>(0);
  const [sizeInSqm, setSizeInSqm] = useState<number>(0);
  const [costPerSqm, setCostPerSqm] = useState<number | null>(null);

  useEffect(() => {
    if (sellingPrice > 0 && sizeInSqm > 0) {
      const cost = calculateCostPerSqm(sellingPrice, sizeInSqm);
      setCostPerSqm(cost);
    } else {
      setCostPerSqm(null);
    }
  }, [sellingPrice, sizeInSqm]);

  return (
    <Card.Body className="p-2">
      <CurrencyInput
        value={sellingPrice}
        onChange={setSellingPrice}
        label="Selling Price"
        required
      />

      <Form.Group className="mb-2">
        <div className="form-group has-float-label">
          <Form.Control
            type="number"
            min="1"
            step="1"
            value={sizeInSqm || ''}
            onChange={(e) => setSizeInSqm(parseFloat(e.target.value) || 0)}
            required
            placeholder=" "
          />
          <span className="required">Size in m²</span>
        </div>
      </Form.Group>

      {costPerSqm !== null && (
        <h3 className="font-weight-bold text-primary mt-3">
          R {formatCurrency(costPerSqm)}{' '}
          <small className="text-muted" style={{ fontSize: '12px' }}>
            Per m²
          </small>
        </h3>
      )}
    </Card.Body>
  );
};

export default CostPerSqm;
